import { eclipseServerData } from '../utils/eclipseServerData';
/**
 * Reseller (e.g. Alibaba) co-branding, sourced from the server.
 *
 * The serverless renderer fetches branding only when the resellerBranding FT is
 * on, so the mere presence of branding here is the "this is a reseller offering"
 * signal (mirrors Sunrise's store).
 */
export const useResellerBranding = () => {
  const {
    resellerBrandingInfo
  } = eclipseServerData.get();
  return {
    isResellerOffering: Boolean(resellerBrandingInfo),
    resellerBrandingInfo
  };
};
//# sourceMappingURL=useResellerBranding.js.map